import React from 'react';
import InputSelectAsync from '../InputSelectAsync';
import { fetchProfessorOptions } from '../../../services/options_services';
import PropTypes from 'prop-types'

const ProfessorInputAsync = (props) => (
  <InputSelectAsync
    key={`${props.params?.clss}${props?.params?.discipline}`}
    loadOptions={(search) => fetchProfessorOptions({ search, ...props.params })}
    getOptionValue={(d) => d.id}
    getOptionLabel={(d) => d.nome}
    {...props}
  />
)

ProfessorInputAsync.propTypes = {
  params: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.object])
  ),
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  defaultOptions: PropTypes.bool,
  noOptionsMessage: PropTypes.string

};

ProfessorInputAsync.defaultProps = {
  params: {},
  name: '',
  label: '',
  placeholder: '',
  disabled: false,
  defaultOptions: false,
  noOptionsMessage: '',
};

export default ProfessorInputAsync;
